import { render, staticRenderFns } from "./signaturePreview.vue?vue&type=template&id=5c6f2a7e&scoped=true"
import script from "./signaturePreview.vue?vue&type=script&lang=js"
export * from "./signaturePreview.vue?vue&type=script&lang=js"
import style0 from "./signaturePreview.vue?vue&type=style&index=0&id=5c6f2a7e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f2a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6f2a7e')) {
      api.createRecord('5c6f2a7e', component.options)
    } else {
      api.reload('5c6f2a7e', component.options)
    }
    module.hot.accept("./signaturePreview.vue?vue&type=template&id=5c6f2a7e&scoped=true", function () {
      api.rerender('5c6f2a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/signaturePreview.vue"
export default component.exports